import React, { Component } from 'react';
import { connect } from 'react-redux';
import Dialog from '../../ui/components/web/Dialog';
import ModeratorTab from '../../../settings/components/web/ModeratorTab';
import { translate } from '../../i18n/functions';
// import { submitProfileTab } from '../../../settings/actions.web';
import { submitModeratorTab } from '../../../settings/actions.web';
import { getModeratorTabProps } from '../../../settings/functions.any';
class ModeratorDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tabState: { ...props.moderatorTabProps }
        };
        this._onSubmitValue = this._onSubmitValue.bind(this);
        this._onChange = this._onChange.bind(this);
    }
    _onSubmitValue() {
        ;
        const { dispatch } = this.props;
        dispatch(submitModeratorTab(this.state.tabState));
    }
    _onChange(tabStateUpdate) {
        this.setState(prevState => ({
            tabState: {
                ...prevState.tabState,
                ...tabStateUpdate // Spread the update object into the existing tabState
            }
        }));
    }
    render() {
        const { t, moderatorTabProps } = this.props;
        moderatorTabProps.onChange = this._onChange;
        return (React.createElement(Dialog, { disableAutoHideOnSubmit: false, ok: {
                translationKey: 'dialog.Ok'
            }, onSubmit: this._onSubmitValue, titleKey: 'settings.moderator' }, React.createElement(ModeratorTab, { ...moderatorTabProps })));
    }
}
function _mapStateToProps(state) {
    return {
        moderatorTabProps: getModeratorTabProps(state)
    };
}
;
export default translate(connect(_mapStateToProps)(ModeratorDialog));
